import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import WebsiteList from 'Components/Presentation/Websites/WebsiteList';
import WebsiteEditContainer from './Edit';

import AllWebsitesQuery from 'GraphQueries/Websites/AllQuery';
import AllChannelsQuery from 'GraphQueries/Channels/AllQuery';
import AllPurchaseModelsQuery from 'GraphQueries/PurchaseModels/AllQuery';
import NewWebsiteMutation from 'GraphQueries/Websites/NewMutation';
import NewWebsiteSubscription from 'GraphQueries/Websites/NewSubscription';
import DeleteWebsiteMutation from 'GraphQueries/Websites/DeleteMutation';
import DeleteWebsiteSubscription from 'GraphQueries/Websites/DeleteSubscription';

class WebsiteIndexContainer extends React.Component {
    
    static defaultProps = {
        channels: [],
        purchaseModels: [],
        websites: [],
        loading: false
    }

    state = { 
        website: null, 
        saving: false
    }

    componentDidMount() {
        const { subscribeToChanges } = this.props;
        subscribeToChanges();
    }

    navigateWithData = (uri, website) => {
        const { history } = this.props;
        this.setState({ website });
        history.push(uri);
    }

    saveWebsite = async (website) => {
        const { onAlert, onAdd } = this.props;
        this.setState({ saving: true });
        onAdd(website).then(x => {
            this.setState({ saving: false });
            this.navigateWithData(`/organisations/websites/${website.id}/manage/settings`, website);
            onAlert('success', `Successfully added website: ${website.id}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to add websites, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    deleteWebsite = async (website) => {
        const { onAlert, onDelete } = this.props;
        this.setState({ saving: true });
        onDelete(website.id).then(x => {
            onAlert('success', `Successfully deleted website: ${website.id}`);
            this.setState({ saving: false });
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to delete websites, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    render() {
        const { websites, channels, purchaseModels, loading, channelsLoading, purchaseModelsLoading } = this.props;
        const { website, saving } = this.state;
        return (
            <React.Fragment>
                <Route path="/organisations/websites" exact render={props => {
                    return (
                        <WebsiteList {...props} loading={loading || channelsLoading || purchaseModelsLoading || saving} 
                            channels={channels} channelsLoading={channelsLoading} purchaseModels={purchaseModels} purchaseModelsLoading={purchaseModelsLoading}
                            onEdit={this.navigateWithData} websites={websites} onWebsiteAdded={this.saveWebsite} onWebsiteRemoved={this.deleteWebsite} />
                    )}
                } />
                <Route path="/organisations/websites/list" render={props => {
                    return (
                        <WebsiteList {...props} loading={loading || channelsLoading || purchaseModelsLoading || saving} 
                            channels={channels} channelsLoading={channelsLoading} purchaseModels={purchaseModels} purchaseModelsLoading={purchaseModelsLoading}
                            onEdit={this.navigateWithData} websites={websites} onWebsiteAdded={this.saveWebsite} onWebsiteRemoved={this.deleteWebsite} />
                    )}
                } />
                <Route path="/organisations/websites/:id/manage" render={routeProps => {
                    return (
                        <WebsiteEditContainer {...this.props} {...routeProps} webiste={website} />
                    )}
                } />
            </React.Fragment>
        );
    }
}

export default compose(
    graphql(AllChannelsQuery(), {
        props: ({ data: { listChannels, loading } }) => ({ channels: listChannels && listChannels.items, channelsLoading: loading })
    }),
    graphql(AllPurchaseModelsQuery(), {
        props: ({ data: { listPurchaseModels, loading } }) => ({ purchaseModels: listPurchaseModels && listPurchaseModels.items, purchaseModelsLoading: loading })
    }),
    graphql(AllWebsitesQuery(), {
        props: ({ data: { listWebsites, loading, subscribeToMore } }) => ({ 
            websites: listWebsites && listWebsites.items, 
            loading,
            subscribeToChanges: params => {
                subscribeToMore({
                    document: NewWebsiteSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateWebsite } } }) => ({
                        ...prev,
                        listWebsites: { items: [onCreateWebsite, ...prev.listWebsites.items.filter(item => item.id !== onCreateWebsite.id)], __typename: 'Website' }
                    })
                });
                subscribeToMore({
                    document: DeleteWebsiteSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteWebsite } } }) => ({
                        ...prev,
                        listWebsites: { items: [...prev.listWebsites.items.filter(item => item.id !== onDeleteWebsite.id)], __typename: 'Website' }
                    })
                });
            }
        })
    }),
    graphql(NewWebsiteMutation(), { props: ({ mutate }) => ({ onAdd: input => mutate({ variables: { input } }) }) }),
    graphql(DeleteWebsiteMutation(), { props: ({ mutate }) => ({ onDelete: id => mutate({ variables: { id } }) }) })
)(WebsiteIndexContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Websites/Index.js